import React, { useEffect, useRef, useState } from 'react'
import { radioOptionsAgentSync, EventHandlingOptions } from '../utils/common'
import { RequiredValidator } from '../utils/validators'
import { FormFieldEntry, PackageModule } from '../components'
import { useEventListener } from '../utils/customHooks';

let maxCount = 10;
let localAgentSettings = null;

const EndpointSettings = ({ agentSettings, updateTenantData }) => {
  const [count, setCount] = useState(0);
  const [isNetworkProtectionEnabled, setIsNetworkProtectionEnabled] = useState(agentSettings.packageDefaults.userControl || 
    agentSettings.packageDefaults.networkAttackDefense ||
    agentSettings.packageDefaults.antiPhishing ||
    agentSettings.packageDefaults.trafficScan);

  let agentSyncLevelRef = useRef(null);
  let agentDestinationMovedRef = useRef(null);
  let rogueAgentFoundRef = useRef(null);
  let agentDestinationDeletedRef = useRef(null);
  let agentDestinationGenesisRef = useRef(null);
  let agentSyncSettingsRef = useRef(null);

  let amModuleRef = useRef(null);
  let atcModuleRef = useRef(null);
  let aaeModuleRef = useRef(null);
  let deviceControlModuleRef = useRef(null);
  let edrSensorModuleRef = useRef(null);
  let encryptionModuleRef = useRef(null);
  let patchManagementModuleRef = useRef(null);
  let firewallModuleRef = useRef(null);
  let powerUserRef = useRef(null);
  let networkProtectionModuleRef = useRef(null);
  let networkAttackDefenseModuleRef = useRef(null);
  let antiPhishingModuleRef = useRef(null);
  let userControlModuleRef = useRef(null);
  let trafficScanModuleRef = useRef(null);
  let removeCompetitorsRef = useRef(null);

  const handleAgentsSyncLevelChange = (e) => {
    let updatedAgentSettings = { ...localAgentSettings, endpointSyncSettings: { ...localAgentSettings.endpointSyncSettings, synchronizeEndpointMode: Number(e.detail.selectedValue) } };

    updateTenantData(updatedAgentSettings);
  }

  const handleAtcModuleChange = (e) => {
    let updatedAgentSettings = { ...localAgentSettings, packageDefaults: { ...localAgentSettings.packageDefaults, advancedThreatControl: e.detail.checked } };

    updateTenantData(updatedAgentSettings);
  }

  const handleAaeModuleChange = (e) => {
    let updatedAgentSettings = { ...localAgentSettings, packageDefaults: { ...localAgentSettings.packageDefaults, advancedAntiExploit: e.detail.checked } };

    updateTenantData(updatedAgentSettings);
  }

  const handleDciModuleChange = (e) => {
    let updatedAgentSettings = { ...localAgentSettings, packageDefaults: { ...localAgentSettings.packageDefaults, deviceControl: e.detail.checked } };

    updateTenantData(updatedAgentSettings);
  }

  const handleEdrModuleChange = (e) => {
    let updatedAgentSettings = { ...localAgentSettings, packageDefaults: { ...localAgentSettings.packageDefaults, edrSensor: e.detail.checked } };

    updateTenantData(updatedAgentSettings);
  }

  const handleEncryptionModuleChange = (e) => {
    let updatedAgentSettings = { ...localAgentSettings, packageDefaults: { ...localAgentSettings.packageDefaults, encryption: e.detail.checked } };

    updateTenantData(updatedAgentSettings);
  }

  const handlePatchMgmtModuleChange = (e) => {
    let updatedAgentSettings = { ...localAgentSettings, packageDefaults: { ...localAgentSettings.packageDefaults, patchManagement: e.detail.checked } };

    updateTenantData(updatedAgentSettings);
  }

  const handleFirewallModuleChange = (e) => {
    let updatedAgentSettings = { ...localAgentSettings, packageDefaults: { ...localAgentSettings.packageDefaults, firewall: e.detail.checked } };

    updateTenantData(updatedAgentSettings);
  }

  const handlePowerUserModuleChange = (e) => {
    let updatedAgentSettings = { ...localAgentSettings, packageDefaults: { ...localAgentSettings.packageDefaults, powerUser: e.detail.checked } };

    updateTenantData(updatedAgentSettings);
  }

  const handleUserControlModuleChange = (e) => {
    let updatedAgentSettings = { ...localAgentSettings, packageDefaults: { ...localAgentSettings.packageDefaults, userControl: e.detail.checked } };

    updateTenantData(updatedAgentSettings);
  }

  const handleTrafficScanModuleChange = (e) => {
    let updatedAgentSettings = { ...localAgentSettings, packageDefaults: { ...localAgentSettings.packageDefaults, trafficScan: e.detail.checked } };

    updateTenantData(updatedAgentSettings);
  }

  const handleAntiPhishingModuleChange = (e) => {
    let updatedAgentSettings = { ...localAgentSettings, packageDefaults: { ...localAgentSettings.packageDefaults, antiPhishing: e.detail.checked } };

    updateTenantData(updatedAgentSettings);
  }

  const handleNadModuleChange = (e) => {
    let updatedAgentSettings = { ...localAgentSettings, packageDefaults: { ...localAgentSettings.packageDefaults, networkAttackDefense: e.detail.checked } };

    updateTenantData(updatedAgentSettings);
  }

  const handleRemoveCompetitorsChange = (e) => {
    let updatedAgentSettings = { ...localAgentSettings, packageDefaults: { ...localAgentSettings.packageDefaults, removeCompetitors: e.detail.checked } };

    updateTenantData(updatedAgentSettings);
  }

  const handleAgentDestinationMovedChange = (e) => {
    let updatedAgentSettings = {
      ...localAgentSettings, endpointSyncSettings: {
        ...localAgentSettings.endpointSyncSettings,
        destinationMovedAuto: e.detail.selectedValue
      }
    };

    updateTenantData(updatedAgentSettings);
  }

  const handleRogueAgentFoundChange = (e) => {
    let updatedAgentSettings = {
      ...localAgentSettings, endpointSyncSettings: {
        ...localAgentSettings.endpointSyncSettings,
        rogueEndpointFoundAuto: e.detail.selectedValue
      }
    };

    updateTenantData(updatedAgentSettings);
  }

  const handleAgentDestinationDeletedChange = (e) => {
    let updatedAgentSettings = {
      ...localAgentSettings, endpointSyncSettings: {
        ...localAgentSettings.endpointSyncSettings,
        destinationDeletedAuto: e.detail.selectedValue
      }
    };

    updateTenantData(updatedAgentSettings);
  }

  const handleAgentDestinationGenesisChange = (e) => {
    let updatedAgentSettings = {
      ...localAgentSettings, endpointSyncSettings: {
        ...localAgentSettings.endpointSyncSettings,
        destinationGenesisAuto: e.detail.selectedValue
      }
    };

    updateTenantData(updatedAgentSettings);
  }

  const handleNetProtModuleChange = (e) => {
    if (e.detail.label === "Network Protection" && e.detail.checked) {
      userControlModuleRef.current.Input.checked = true;
      networkAttackDefenseModuleRef.current.Input.checked = true;
      antiPhishingModuleRef.current.Input.checked = true;
      trafficScanModuleRef.current.Input.checked = true;
      setIsNetworkProtectionEnabled(true);
    } else if (e.detail.label === "Network Protection" && !e.detail.checked) {
      setIsNetworkProtectionEnabled(false);
    }

    let updatedAgentSettings = { ...localAgentSettings, packageDefaults: { ...localAgentSettings.packageDefaults, networkAttackDefense: e.detail.checked, userControl: e.detail.checked, antiPhishing: e.detail.checked, trafficScan: e.detail.checked} };
    updateTenantData(updatedAgentSettings);
  }

  useEventListener({ eventName: 'radioSelectionChanged', handler: handleAgentsSyncLevelChange, ref: agentSyncLevelRef })
  useEventListener({ eventName: 'change', handler: handleAtcModuleChange, ref: atcModuleRef })
  useEventListener({ eventName: 'change', handler: handleAaeModuleChange, ref: aaeModuleRef })
  useEventListener({ eventName: 'change', handler: handleDciModuleChange, ref: deviceControlModuleRef })
  useEventListener({ eventName: 'change', handler: handleEdrModuleChange, ref: edrSensorModuleRef })
  useEventListener({ eventName: 'change', handler: handleEncryptionModuleChange, ref: encryptionModuleRef })
  useEventListener({ eventName: 'change', handler: handlePatchMgmtModuleChange, ref: patchManagementModuleRef })
  useEventListener({ eventName: 'change', handler: handleFirewallModuleChange, ref: firewallModuleRef })
  useEventListener({ eventName: 'change', handler: handlePowerUserModuleChange, ref: powerUserRef })
  useEventListener({ eventName: 'change', handler: handleUserControlModuleChange, ref: userControlModuleRef })
  useEventListener({ eventName: 'change', handler: handleAntiPhishingModuleChange, ref: antiPhishingModuleRef })
  useEventListener({ eventName: 'change', handler: handleTrafficScanModuleChange, ref: trafficScanModuleRef })
  useEventListener({ eventName: 'change', handler: handleNadModuleChange, ref: networkAttackDefenseModuleRef })
  useEventListener({ eventName: 'change', handler: handleRemoveCompetitorsChange, ref: removeCompetitorsRef })
  useEventListener({ eventName: 'change', handler: handleNetProtModuleChange, ref: networkProtectionModuleRef })

  useEffect(() => {
    window.scrollTo(0, 0);
    agentSyncSettingsRef.current.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    localAgentSettings = { ...agentSettings };

    if (agentSettings.packageDefaults.userControl 
      || agentSettings.packageDefaults.networkAttackDefense
      || agentSettings.packageDefaults.antiPhishing
      || agentSettings.packageDefaults.trafficScan) {
      networkProtectionModuleRef.current.Input.checked = true;
      setIsNetworkProtectionEnabled(true);
    } else {
      networkProtectionModuleRef.current.Input.checked = false;
    }
  }, [agentSettings])

  useEffect(() => {
    if (!isNetworkProtectionEnabled) {
      userControlModuleRef.current.Input.checked = false;
      networkAttackDefenseModuleRef.current.Input.checked = false;
      antiPhishingModuleRef.current.Input.checked = false;
      trafficScanModuleRef.current.Input.checked = false;
    }
  }, [isNetworkProtectionEnabled]);

  useEffect(() => {
    if (count === maxCount) {
      return;
    }

    let localAgentDestinationMovedRef = null;
    let localRogueAgentFoundRef = null;
    let localAgentDestinationDeletedRef = null;
    let localAgentDestinationGenesisRef = null;

    if (agentDestinationMovedRef.current.childNodes[0].dropdownMenu) {
      localAgentDestinationMovedRef = agentDestinationMovedRef.current;
      localRogueAgentFoundRef = rogueAgentFoundRef.current;
      localAgentDestinationDeletedRef = agentDestinationDeletedRef.current;
      localAgentDestinationGenesisRef = agentDestinationGenesisRef.current;

      agentDestinationMovedRef.current.childNodes[0].dropdownMenu.canDelete = false;
      rogueAgentFoundRef.current.childNodes[0].dropdownMenu.canDelete = false;
      agentDestinationDeletedRef.current.childNodes[0].dropdownMenu.canDelete = false;
      agentDestinationGenesisRef.current.childNodes[0].dropdownMenu.canDelete = false;
    }
    if (agentDestinationMovedRef.current.childNodes[0].selectList) {
      agentDestinationMovedRef.current.childNodes[0].selectList.addEventListener('selectionChange', handleAgentDestinationMovedChange);
      rogueAgentFoundRef.current.childNodes[0].selectList.addEventListener('selectionChange', handleRogueAgentFoundChange);
      agentDestinationDeletedRef.current.childNodes[0].selectList.addEventListener('selectionChange', handleAgentDestinationDeletedChange);
      agentDestinationGenesisRef.current.childNodes[0].selectList.addEventListener('selectionChange', handleAgentDestinationGenesisChange);
    } else {
      setCount(prev => prev + 1);
    }

    return (() => {
      if (localAgentDestinationMovedRef && localRogueAgentFoundRef && localAgentDestinationDeletedRef && localAgentDestinationGenesisRef) {
        localAgentDestinationMovedRef.removeEventListener('selectionChange', handleAgentDestinationMovedChange);
        localRogueAgentFoundRef.removeEventListener('selectionChange', handleRogueAgentFoundChange);
        localAgentDestinationDeletedRef.removeEventListener('selectionChange', handleAgentDestinationDeletedChange);
        localAgentDestinationGenesisRef.removeEventListener('selectionChange', handleAgentDestinationGenesisChange);
      }
    })
  }, [count])

  useEffect(() => {
    agentDestinationMovedRef.current.validators = [RequiredValidator('Required field')];
    rogueAgentFoundRef.current.validators = [RequiredValidator('Required field')];
    agentDestinationDeletedRef.validators = [RequiredValidator('Required field')];
    agentDestinationGenesisRef.validators = [RequiredValidator('Required field')];

    agentSyncLevelRef.current.selectedOption = JSON.stringify(agentSettings.endpointSyncSettings.synchronizeEndpointMode);
  }, [agentSettings]);

  return (
    <div>
      <div className='flex flex-col ml-8 mt-8 p-2'>
        <div className='mb-2' ref={agentSyncSettingsRef}>
          <gz-title fontSize="18" fontWeight="500">Agents synchronization</gz-title>
        </div>
        <div className='mb-2'>
          <gz-text fontSize="12">
            Use the options on this page to automate the deployment of the Bitdefender agent to your synchronized inventory.
          </gz-text>
        </div>
        <div className='mt-6 mb-2'>
          <gz-title fontSize="18" fontWeight="500">Synchronization level</gz-title>
        </div>
        <div className=' flex flex-row items-center'>
          <FormFieldEntry
            ref={agentSyncLevelRef}
            formFieldId="radio_group_agent_level"
            typeOfEnclosing="gz-radio-group"
            value={radioOptionsAgentSync}
          />
        </div>
        <div className='mt-4 mb-2'>
          <gz-title fontSize="18" fontWeight="500">Deployment package</gz-title>
        </div>
        <div className='mb-3'>
          <gz-text fontSize="12">
            Select the modules to install by default with the Bitdefender agent.
          </gz-text>
        </div>
        <div >
          <gz-title fontSize='10' fontWeight='400'> Modules </gz-title>
          <div className='form-section mt-3'>
            <PackageModule
              isWindows={true}
              isMacOS={true}
              isLinux={true}
              moduleAcronym={'am'}
              label={'Antimalware'}
              isChecked={true}
              isReadOnly={true}
              value={true}
              ref={amModuleRef}
            />
            <PackageModule
              isWindows={true}
              isMacOS={true}
              isLinux={false}
              moduleAcronym={'atc'}
              isChecked={agentSettings.packageDefaults.advancedThreatControl}
              value={agentSettings.packageDefaults.advancedThreatControl}
              label={'Advanced Threat Control'}
              isReadOnly={false}
              ref={atcModuleRef}
            />
            <PackageModule
              isWindows={true}
              isMacOS={false}
              isLinux={true}
              moduleAcronym={'aae'}
              label={'Advanced Anti-Exploit'}
              isChecked={agentSettings.packageDefaults.advancedAntiExploit}
              value={agentSettings.packageDefaults.advancedAntiExploit}
              isReadOnly={false}
              ref={aaeModuleRef}
            />
            <PackageModule
              isWindows={true}
              isMacOS={true}
              isLinux={false}
              moduleAcronym={'dci'}
              label={'Device Control'}
              isChecked={agentSettings.packageDefaults.deviceControl}
              value={agentSettings.packageDefaults.deviceControl}
              isReadOnly={false}
              ref={deviceControlModuleRef}
            />
            <PackageModule
              isWindows={true}
              isMacOS={true}
              isLinux={true}
              moduleAcronym={'edr'}
              label={'EDR Sensor'}
              isChecked={agentSettings.packageDefaults.edrSensor}
              value={agentSettings.packageDefaults.edrSensor}
              isReadOnly={false}
              ref={edrSensorModuleRef}
            />
            <PackageModule
              isWindows={true}
              isMacOS={true}
              isLinux={false}
              moduleAcronym={'encrypt'}
              label={'Encryption'}
              isChecked={agentSettings.packageDefaults.encryption}
              value={agentSettings.packageDefaults.encryption}
              isReadOnly={false}
              ref={encryptionModuleRef}
            />
            <PackageModule
              isWindows={true}
              isMacOS={true}
              isLinux={true}
              moduleAcronym={'patchMgmt'}
              label={'Patch Management'}
              isChecked={agentSettings.packageDefaults.patchManagement}
              value={agentSettings.packageDefaults.patchManagement}
              isReadOnly={false}
              ref={patchManagementModuleRef}
            />
            <PackageModule
              isWindows={true}
              isMacOS={false}
              isLinux={false}
              moduleAcronym={'fw'}
              label={'Firewall'}
              isChecked={agentSettings.packageDefaults.firewall}
              value={agentSettings.packageDefaults.firewall}
              isReadOnly={false}
              ref={firewallModuleRef}
            />
            <PackageModule
              isWindows={true}
              isMacOS={false}
              isLinux={false}
              moduleAcronym={'pwrUser'}
              label={'Power User'}
              isChecked={agentSettings.packageDefaults.powerUser}
              value={agentSettings.packageDefaults.powerUser}
              isReadOnly={false}
              ref={powerUserRef}
            />
            <PackageModule
              isWindows={true}
              isMacOS={true}
              isLinux={false}
              moduleAcronym={'netProtection'}
              label={'Network Protection'}
              isChecked={isNetworkProtectionEnabled}
              value={isNetworkProtectionEnabled}
              isReadOnly={false}
              ref={networkProtectionModuleRef}
            />
            <div className='ml-6'>
              <PackageModule
                isWindows={true}
                isMacOS={true}
                isLinux={false}
                moduleAcronym={'cc'}
                label={'Content Control'}
                isChecked={agentSettings.packageDefaults.userControl}
                value={agentSettings.packageDefaults.userControl}
                isReadOnly={false}
                ref={userControlModuleRef}
              />
              <PackageModule
                isWindows={true}
                isMacOS={true}
                isLinux={false}
                moduleAcronym={'aph'}
                label={'Antiphishing'}
                isChecked={agentSettings.packageDefaults.antiPhishing}
                value={agentSettings.packageDefaults.antiPhishing}
                isReadOnly={false}
                ref={antiPhishingModuleRef}
              />
              <PackageModule
                isWindows={true}
                isMacOS={true}
                isLinux={false}
                moduleAcronym={'wts'}
                label={'Web Traffic Scan'}
                isChecked={agentSettings.packageDefaults.trafficScan}
                value={agentSettings.packageDefaults.trafficScan}
                isReadOnly={false}
                ref={trafficScanModuleRef}
              />
              <PackageModule
                isWindows={true}
                isMacOS={true}
                isLinux={true}
                moduleAcronym={'nad'}
                label={'Network Attack Defense'}
                isChecked={agentSettings.packageDefaults.networkAttackDefense}
                value={agentSettings.packageDefaults.networkAttackDefense}
                isReadOnly={false}
                ref={networkAttackDefenseModuleRef}
              />
            </div>
          </div>
          <div className='mt-3'>
            <gz-title fontSize='10' fontWeight='400'> Additional Settings </gz-title>
          </div>
          <div className='mt-3'>
            <FormFieldEntry
              ref={removeCompetitorsRef}
              label="Remove Competitors"
              formFieldId="removeCompetitors"
              typeOfEnclosing="gz-checkbox"
              value={agentSettings.packageDefaults.removeCompetitors}
              isChecked={agentSettings.packageDefaults.removeCompetitors}
            />
          </div>
        </div>
        <div className='mt-4 mb-2'>
          <gz-title fontSize="18" fontWeight="500">Synchronization event handling</gz-title>
        </div>
        <div className='mb-3'>
          <gz-text fontSize="12">
            Select event handling settings during synchronization.
          </gz-text>
        </div>
        <FormFieldEntry
          ref={agentDestinationMovedRef}
          label="Destination moved"
          formFieldId="agent_destination_moved"
          typeOfEnclosing="gz-single-select"
          placeholder="Select value"
          description="The destination for the agent was moved from its original location. Move the destination agent according to the position of the source agent."
          filterOptions={EventHandlingOptions}
          value={agentSettings.endpointSyncSettings.destinationMovedAuto}
        />
        <FormFieldEntry
          ref={rogueAgentFoundRef}
          label="Rogue Bitdefender agent found"
          formFieldId="rogue_agent_found"
          typeOfEnclosing="gz-single-select"
          placeholder="Select value"
          description="The destination for the agent was found outside the target organization or tenant. Move the destination agent according to the position of the source agent. This action will force the removal and reinstallation of the Bitdefender agent on the target endpoint."
          filterOptions={EventHandlingOptions}
          value={agentSettings.endpointSyncSettings.rogueEndpointFoundAuto}
        />
        <FormFieldEntry
          ref={agentDestinationDeletedRef}
          label="Destination deleted"
          formFieldId="agent_destination_deleted"
          typeOfEnclosing="gz-single-select"
          placeholder="Select value"
          description="Bitdefender security product was uninstalled from the source agent. Reinstall the Bitdefender security product."
          filterOptions={EventHandlingOptions}
          value={agentSettings.endpointSyncSettings.destinationDeletedAuto}
        />
        <FormFieldEntry
          ref={agentDestinationGenesisRef}
          label="Install Bitdefender Agent"
          formFieldId="agent_destination_genesis"
          typeOfEnclosing="gz-single-select"
          placeholder="Select value"
          description="The Bitdefender security product is not installed on the source agent. Install the Bitdefender security product."
          filterOptions={EventHandlingOptions}
          value={agentSettings.endpointSyncSettings.destinationGenesisAuto}
        />
      </div>
    </div>
  )
}

export default EndpointSettings